import { HStack, VStack } from "@/components/Layout";
import { createFileRoute } from "@tanstack/react-router";
import PublicIdInformationNavigation from "../../../-components/PersonProfileSection/public-id-information/PublicIdInformationNavigation";
import ResidenceStatusSection from "../../../-components/PersonProfileSection/public-id-information/ResidenceStatusSection";

export const Route = createFileRoute("/_staff/person/$id/_profile/public-id/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <HStack className="h-full">
      <nav className="sticky top-0 h-fit w-60 p-8">
        <PublicIdInformationNavigation />
      </nav>
      <div className="flex-1 overflow-y-auto p-8">
        <VStack className="w-full gap-4">
          {/* TODO: パスポート情報は未実装 */}
          {/* <PassportSection /> */}
          <ResidenceStatusSection />
          {/* TODO: ワークビザ情報は未実装 */}
          {/* <WorkVisaSection /> */}
        </VStack>
      </div>
    </HStack>
  );
}
